// Color options used for custom colors, chart colors (below), etc.
export const COLOR_OPTIONS = [
  { value: '#0088FE', name: 'azure' },
  { value: '#00C49F', name: 'mint' },
  { value: '#FFBB28', name: 'sunflower' },
  { value: '#1289A7', name: 'teal' },
  { value: '#79001A', name: 'burgundy' },
  { value: '#F44336', name: 'pomegranate' },
  { value: '#009432', name: 'shamrock' },
  { value: '#455A64', name: 'gray' },
  { value: '#7C4DFF', name: 'purple' }, // (don't remove this without updating DEFAULT_CUSTOM_LAYER_COLOR)
  { value: '#C2185B', name: 'maroon' },
  { value: '#8BC34A', name: 'pea' },
  { value: '#FF5722', name: 'papaya' },
  { value: '#795548', name: 'brown' },
  { value: '#163200', name: 'forest' },
  { value: '#000000', name: 'black' }, // not used in charts
  { value: '#ffffff', name: 'white' }, // not used in charts
] as const;

export const BRIGHT_COLOR_OPTIONS = [
  { value: '#EA3323', name: 'red' },
  { value: '#EE792F', name: 'orange' },
  { value: '#F7D046', name: 'yellow' },
  { value: '#A3DC44', name: 'lime' },
  { value: '#4FAE49', name: 'green' },
  { value: '#57BEE5', name: 'sky' },
  { value: '#4277F6', name: 'blue' },
  { value: '#B233F6', name: 'purple' },
  { value: '#EE7BF8', name: 'pink' },
] as const;

export const DEFAULT_CUSTOM_LAYER_COLOR = COLOR_OPTIONS.find(
  (c) => c.name === 'purple',
)!.value;

// TODO add more colors when needed
export const CHART_COLORS = COLOR_OPTIONS.filter(
  (c) => !['black', 'white'].includes(c.name),
).map((c) => c.value);

export const BRIGHT_COLORS = BRIGHT_COLOR_OPTIONS.map(({ value }) => value);

// Used for the inactive items in a chart when an item is active
export const INACTIVE_CHART_COLOR = '#aaa';

export const OTHER_COLOR = '#ccc';
